import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authSlice from "./reducers/authSlice";
import { movieApi } from "../redux/services/movieApi";
import { userApi } from "../redux/services/userApi";
import { favoritesApi } from "./services/favoritesApi";
import resizeSlice from "./reducers/resizeSlice";

const rootReducer = combineReducers({
  authSlice,
  resizeSlice,
  [movieApi.reducerPath]: movieApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [favoritesApi.reducerPath]: favoritesApi.reducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(movieApi.middleware)
        .concat(userApi.middleware)
        .concat(favoritesApi.middleware),
        
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
